import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { messagePropType } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import MoreDetails from "app/pages/.shared/MoreDetails";
import PaymentCouponItem from "app/pages/Booking/Payment/PaymentCoupons/PaymentCouponItem/PaymentCouponItem";
import AlertMessage from "app/pages/.shared/AlertMessage";

import "./OnlyNonApplicableCouponMessage.scss";

const OnlyNonApplicableCouponMessage = ({ title, message, coupons, onShow }) => {
	useEffect(() => {
		onShow();
	}, []);

	return (
		<div className="only-non-applicable-coupon-message">
			<AlertMessage message={title}>
				<div className="only-non-applicable-coupon-message__title">{message}</div>
				<MoreDetails
					expandedLabel={<FormattedMessage id="product.page.less.details" />}
					collapsedLabel={<FormattedMessage id="product.page.more.details" />}
				>
					{coupons.map(coupon => {
						return (
							<div
								key={coupon.title}
								className="only-non-applicable-coupon-message__item"
							>
								<PaymentCouponItem
									friendEmail={coupon.friendEmail}
									source={coupon.source}
									amount={coupon.amount}
									creationDate={coupon.creationDate}
									balance={coupon.balance}
									uses={coupon.uses}
									maxUseDate={coupon.maxUseDate}
									conditions={coupon.conditions}
									title={coupon.title}
									usableAmount={coupon.usableAmount}
									disabled={true}
								/>
							</div>
						);
					})}
				</MoreDetails>
			</AlertMessage>
		</div>
	);
};

OnlyNonApplicableCouponMessage.propTypes = {
	title: messagePropType,
	message: messagePropType,
	coupons: PropTypes.array,
	onShow: PropTypes.func,
};

OnlyNonApplicableCouponMessage.defaultProps = {
	coupons: [],
	onShow: () => {},
};

export default memo(OnlyNonApplicableCouponMessage);
